<template>
  <div>
    <div
      class="h-panel"
    >
      <b-button v-b-modal.help-modal>Help</b-button>
    </div>

    <p v-if="message !== null">
      {{message}}
    </p>

    <table v-if="sessions !== null && sessions.length > 0" class="table text-nowrap">
      <thead class="thead-dark">
        <tr>
          <th scope="col">Start</th>
          <th scope="col">Platform</th>
          <th scope="col">User id</th>
          <th scope="col">Advertising id</th>
          <th scope="col">Levels complete</th>
        </tr>
      </thead>
      <tr
        v-for="session in sessions"
        :key="session.startTime"
      >
        <td>
          {{session.startTime | getMomentStr}}
        </td>
        <td>
          {{session.platform | getPlatformName}}
        </td>
        <td>
          {{session.userId}}
        </td>
        <td>
          {{session.advertisingId}}
        </td>
        <td class="text-right">
          {{session.m3LevelsComplete}}
        </td>
      </tr>
    </table>

    <loading-indicator
      v-if="isLoading"
    />

    <b-modal id="help-modal" title="Справка" ok-only ok-title="Close">
      <div class="help">
        <p>
          На данной странице показан журнал сессий использования приложения
          (журнал игровых сессий). Здесь показаны игровые сессии
          (а&nbsp;не&nbsp;сетевые сессии, т.е. не&nbsp;сессии взаимодейстия клиента игры с&nbsp;сервером игры).
          Игрок может запустить игру без&nbsp;интернета.
          В этом случае начинается игровая сессия, а&nbsp;сетевая сессия не&nbsp;начинается.
        </p>
        <p>
          Для события показан идентификатор пользователя (User&nbsp;id) полученный с&nbsp;помощью
          <a href="https://docs.unity3d.com/ScriptReference/Analytics.AnalyticsSessionInfo-userId.html">AnalyticsSessionInfo.userId</a>
          в&nbsp;момент отправки событий на&nbsp;сервер событий
          (а не&nbsp;в&nbsp;момент запуска приложения).
        </p>
        <p>
          Для события показан рекламный идентификатор (Advertising&nbsp;id) полученный
          в&nbsp;момент отправки событий на&nbsp;сервер событий
          (а не&nbsp;в&nbsp;момент запуска приложения).
        </p>
      </div>
    </b-modal>

  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';

export default {
  name: 'PlayerAppSessionsLog',

  components: {
    LoadingIndicator,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      sessions: null,
    };
  },

  computed: {
    message() {
      if(this.sessions !== null && this.sessions.length === 0) {
        return 'No app sessions.';
      }
      return null;
    },
  },

  created() {
    notifier.deleteSenderNotifications(this);

    this.isLoading = true;

    const url = `/player/${this.playerId}/app_session_log`;
    HTTP.get(url)
    .then(response => {
      this.isLoading = false;

      const data = response.data.data;
      if(data === null) {
        notifier.showError('Invalid server response. data === null.', {sender: this});
        return;
      }

      const sessions = data;
      sessions.sort((a, b) => b.startTime - a.startTime);

      this.sessions = sessions;
    })
    .catch(e => {
      this.isLoading = false;
      notifier.showError(e.response.data, {sender: this});
    });
  },
};
</script>
